import { useEffect, useRef, useState } from 'react';
import type { Key } from 'react';
import { Tree } from 'antd';
import { TreeViewProps } from '@/types/views';
import { FolderOpenOutlined, FolderOutlined } from '@ant-design/icons';
import styles from '@/styles/documents.module.css';

const TreeView = ({
  width,
  documentView,
  currentNode,
  setOpenModal,
  expandedKeys,
  onExpand,
  onFolderNameClick,
  items,
}: TreeViewProps & { onFolderNameClick?: (node: any) => void }) => {
  const treeRef = useRef<any>(null);
  const [treeWidth, setTreeWidth] = useState(0);

  useEffect(() => {
    if (treeRef.current) {
      const currentWidth = treeRef.current?.offsetWidth;
      setTreeWidth(currentWidth);
    }
  }, [width]);

  const handleSelect = (selectedKeys: Key[], info: any) => {
    const { node } = info;
    if (onFolderNameClick && !node.isLeaf) {
      onFolderNameClick(node);
    }
  };

  const handleExpand = (expandedKeys: Key[], info: any) => {
    onExpand(expandedKeys, info);
  };

  return (
    <div ref={treeRef}>
      <Tree
        className={styles.treeview}
        selectedKeys={[currentNode?.key]}
        showLine={false}
        treeData={documentView.transformTreeData(
          documentView.treeData,
          treeWidth,
          setOpenModal,
          items,
        )}
        expandedKeys={expandedKeys}
        onExpand={handleExpand}
        onSelect={handleSelect}
        switcherIcon={(props: any) =>
          props.expanded ? (
            <FolderOpenOutlined />
          ) : (
            <FolderOutlined rotate={360} />
          )
        }
      />
    </div>
  );
};
export default TreeView;
